export default {
  'apiUrl': 'https://kolyom.wecandevelopit.com',
  'version': '/api/v1',
  'defaultLang': 'en',
  'appName': 'Kol-Yom'
}



// WEBPACK FOOTER //
// ./src/settings.js